import { FiArrowUpRight } from "react-icons/fi";

export default function StatisticsCards({ handleClick, stats }) {
  const categories = [
    { name: "Active Leads", key: "activeLeads" },
    { name: "Pending Leads", key: "pendingLeads" },
    { name: "Payment Pending", key: "pendingPayments" },
    { name: "Finalized Leads", key: "finalizedLeads" },
    { name: "Visa Applied", key: "visaAppliedLeads" },
    { name: "Total Leads", key: "totalLeads" },

  ];
console.log(stats , "stats")
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5">
      {categories.map(({ name, key }) => (
        <div
          key={key}
          className="bg-white p-4 rounded-lg shadow-custom transition-shadow"
          onClick={() => handleClick(name)}
        >
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-lg text-gray-800">{name}</h3>
              <p className="text-2xl font-semibold mt-2">{stats?.[key] || 0}</p>
            </div>
            <FiArrowUpRight className="w-5 h-5 text-gray-400" />
          </div>
        </div>
      ))}
    </div>
  );
}
